// extracted by mini-css-extract-plugin
export default {"container":"Reviews-module--container--oYnY7","slide":"Reviews-module--slide--mBYjW"};